import styled, { css } from "styled-components";
import { Screen, Color } from 'styles';
import { NavLink } from 'react-router-dom';


export const StyledWrapper = styled.div`
  background: url(${prop => prop.background}) no-repeat top center;
  background-size: cover;
  width: 100%;
`;

export const StyledSlide = styled.div`
  align-items: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  
  &:focus {
    outline: 0;
  }
`;

const SmallHeaderStyle = css`
  font-size: 40px;
  line-height: 50px;
  min-width: 193px;
`;

const MediumHeaderStyle = css`
  font-size: 100px;
`;

export const StyledHeader = styled.h2`
  color: ${Color.White};
  font-size: 148px;
  line-height: 140px;
  
  
  ${Screen.medium(MediumHeaderStyle)}
  ${Screen.small(SmallHeaderStyle)}
`;

const SmallDescriptionStyle = css`
  font-size: 20px;
`;

const MediumDescriptionStyle = css`
  font-size: 40px;
`;

export const StyledDescription = styled.div`
  color: ${Color.Black};
  font-size: 51px;
  text-transform: uppercase
  
  ${Screen.medium(MediumDescriptionStyle)}
  ${Screen.small(SmallDescriptionStyle)}
`;

export const StyledSliderDots = styled.div`
    bottom: -5px;
    left: 0;
    position: absolute;
    right: 0;
`;

export const StyledSlideDot = styled.span`
  border-right: 1px solid ${Color.Black};
  background-color: ${props => props.active ? Color.Orange : Color.White};
  cursor: pointer;
  display: inline-block;
  height: 10px;
  width: 20%;
  
  &:hover {
    background-color: ${Color.Orange};
  }
  
  &:last-child {
    border-right:0;
  }
`;

export const StyledSlideTitle = styled.div`
  display: inline-block;
  position: relative;
  
  &:after {
    background-color: ${Color.Orange};
    content: '';
    display: block;
    height: 135px;
    position: absolute;
    right: 0;
    width: 5000px;
    bottom: -22px;
    z-index: -1;
    right: -22px;
  }
`;

export const StyledSlideLink = styled(NavLink)`
  background: ${Color.Black};
  color: ${Color.White};
  font-size: 14px;
  position: absolute;
  right: -22px;
  bottom: -62px;
  padding: 10px 20px;
  
  &:hover {
    opacity: 0.7;
  }
`;


// WEBPACK FOOTER //
// ./src/components/slider/slider.style.js